// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1IdentitySchema } from './v1/identitySchema';
import { v1IdentityUpdateSchema } from './v1/identity/updateSchema';

export const updateUserIdentityHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string().describe("Bearer token")),
});

/**
 * @description identity updated
 */
export const updateUserIdentity200Schema = z.lazy(() => v1IdentitySchema);

/**
 * @description unauthorized
 */
export const updateUserIdentity401Schema = z.unknown();

/**
 * @description validation errors
 */
export const updateUserIdentity422Schema = z.object({
  errors: z.optional(z.object({})),
});

export const updateUserIdentityMutationRequestSchema = z.lazy(() => v1IdentityUpdateSchema);

export const updateUserIdentityMutationResponseSchema = z.lazy(() => updateUserIdentity200Schema);
